// extracted by mini-css-extract-plugin
export default {"header":"Header_header__5fmM2","hipraLogo":"Header_hipraLogo__GjMHf","title":"Header_title__3nH0d","dropdownMenuItem":"Header_dropdownMenuItem__hqh+P"};